import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'uk',
    fullName: 'Ukrainian',
    nativeName: 'Українська',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Наближається щось дивовижне",
    landing_subtitle: "ArgVoid — студія розробки додатків та ігор. Слідкуйте за оновленнями, незабаром будуть новинки!",
    select_language: "Виберіть мову",
    search_placeholder: "Пошук мов...",
    terms_title: "Умови обслуговування",
    policy_title: "Політика конфіденційності",
    cookies_title: "Політика використання файлів cookie",
    terms_content: `
        <strong>1. Прийняття Умов </strong><br>
        Отримавши доступ до ArgVoid, ви приймаєте ці Умови використання. Якщо ці умови не згодні, послуга не повинна використовуватися.<br><br>

        <strong>2. Використання платформи </strong><br>
        ArgVoid і його програми надаються «як є» для інформаційних і творчих цілей. Сервіс має використовуватися лише в законних цілях.<br><br>

        <strong>3. Заборонена поведінка </strong><br>
        Використання вразливостей сайту, спам або спроба несанкціонованого доступу до інфраструктури суворо заборонені.<br><br>

        <strong>4. Відмова від відповідальності </strong><br>
        Платформа та послуги можуть бути змінені в будь-який час без попередження. Не надається гарантія щодо часу безвідмовної роботи або доступності служби.
    `,
    policy_content: `
        <strong>1. Збірка інформації </strong><br>
        Платформа наразі не вимагає автентифікації користувача чи створення облікового запису. Жодна особиста інформація (наприклад, імена чи адреси електронної пошти) активно не збирається від відвідувачів. <br><br>

        <strong>2. Дані використання </strong><br>
        Можна збирати базову анонімну аналітику, щоб зрозуміти відвідуваність сайту та покращити програми. Ці дані не пов’язані з ідентифікаторами окремих користувачів.<br><br>

        <strong>3. Послуги третіх сторін </strong><br>
        Для послуг хостингу та аналітики можуть використовуватися сторонні постачальники. Практика конфіденційності цих відповідних постачальників регулює анонімні дані, які обробляються в їхній інфраструктурі.<br><br>

        <strong>4. Безпека даних </strong><br>
        Для захисту платформи вживаються розумні заходи безпеки. Однак жоден метод передачі через Інтернет не є повністю безпечним.<br><br>
    `,
    cookies_content: `
        <strong>1. Що таке файли cookie та локальне сховище? </strong><br>
        Файли cookie та локальне сховище браузера – це невеликі файли даних, які зберігаються на пристрої для запам’ятовування налаштувань конфігурації під час відвідувань.<br><br>

        <strong>2. Призначення </strong><br>
        LocalStorage браузера використовується лише для збереження налаштувань конфігурації, наприклад: <br>
        - Мовні налаштування <br>
        - Конфігурація інтерфейсу користувача (наприклад, налаштування макета або теми) <br>
        — Тимчасовий кеш програми <br><br>

        <strong>3. Без відстеження </strong><br>
        Файли cookie та локальне сховище не використовуються для реклами чи стороннього відстеження. Усі збережені дані суто призначені для основної функціональності платформи.<br><br>

        <strong>4. Control</strong><br>
        Дані веб-переглядача можна будь-коли очистити в налаштуваннях веб-переглядача, що призведе до скидання будь-яких локальних конфігурацій.
    `,
    cookie_consent_text: "Ми використовуємо базові файли cookie, щоб забезпечити правильну роботу веб-сайту, наприклад, підтримувати ваш сеанс активним, зберігати ваші мовні налаштування та інші спеціальні конфігурації.",
    read_policy: "Прочитайте політику використання файлів cookie",
    support_title: "Зверніться до служби підтримки",
    support_subject_label: "Тема",
    support_message_label: "повідомлення",
    support_submit_button: "Надіслати повідомлення",
    support_hint: "Примітка. Відкриється програма електронної пошти за замовчуванням для надсилання повідомлення.",
    support_success_msg: "Відкриття програми електронної пошти...",
    support_error_msg: "Не вдалося надіслати повідомлення. Спробуйте пізніше.",
    explorer_title: "Провідник",
    history_title: "історія",
    animation_title: "Анімація",
    config_title: "Конфігурація",
    tool_mouse: "Вибрати (Ctrl+M)",
    tool_brush: "Кисть (Ctrl+B)",
    tool_brush_mode: "Режим перемикання (суцільний/чистий)",
    tool_eraser: "Гумка (Ctrl+E)",
    tool_brush_size: "Відрегулюйте розмір пензля",
    tool_bucket: "Заливка (Ctrl+F)",
    tool_eyedropper: "Очна піпетка",
    tool_grid: "Сітка (Ctrl+Shift+B)",
    tool_rotate: "Повернути (Ctrl+Shift+R)",
    tool_flip_h: "Перевернути H (Ctrl+Shift+H)",
    tool_flip_v: "Перевернути V (Ctrl+Shift+V)",
    tool_transpose: "Транспонування (Ctrl+Shift+T)",
    label_width: "Ширина",
    label_height: "Висота",
    label_frames: "Кількість кадрів",
    label_animation: "Стиль анімації",
    label_background_color: "Колір фону",
    label_interval: "Інтервал",
    tool_anim_config: "Конфігурація анімації",
    label_new_width: "Нова ширина",
    label_new_height: "Нова висота",
    label_apply: "Застосувати",
    label_colors: "Кольори",
    label_size: "Розмір",
    label_tolerance: "Толерантність",
    val_horizontal: "Горизонтальний",
    val_vertical: "Вертикальний",
    val_sequence: "Послідовність",
    val_bounce: "Відскок",
    val_random: "Випадковий",
    val_solid: "Твердий",
    val_clear: "ясно",
    action_add_sheet: "Новий аркуш",
    action_import: "Імпорт",
    action_export: "Експорт",
    action_sort_projects: "Сортувати",
    sort_date_old: "Спочатку найстаріший",
    sort_date_new: "Спочатку найновіші",
    sort_name_az: "Ім'я (А-Я)",
    sort_name_za: "Ім'я (Я-А)",
    action_new_sprite: "Новий спрайт",
    action_new_project: "Новий проект",
    modal_save_all_title: "Зберегти всі зміни",
    modal_save_all_desc: "Виберіть активи для збереження:",
    modal_save_selected: "Зберегти вибране",
    action_saved: "Збережено",
    modal_create_sprite_title: "Створити новий спрайт",
    modal_create_project_title: "Створити новий проект",
    modal_add_sheet_title: "Додати новий аркуш",
    modal_rename_sheet_title: "Перейменувати аркуш",
    modal_rename_sprite_title: "Перейменувати Sprite",
    modal_delete_sprite_title: "Видалити спрайт",
    modal_delete_project_title: "Видалити проект",
    modal_delete_sheet_title: "Видалити аркуш",
    placeholder_sprite_name: "Ім'я",
    placeholder_project_name: "Ім'я",
    placeholder_sheet_name: "Ім'я",
    placeholder_new_name: "Нова назва",
    action_create: "Створити",
    action_add: "додати",
    action_rename: "Перейменувати",
    action_duplicate: "дублікат",
    action_delete: "Видалити",
    action_cancel: "Скасувати",
    confirm_delete_sprite: "Ви впевнені, що хочете видалити цей спрайт?",
    confirm_delete_project: "Ви впевнені, що хочете видалити цей проект? Усі спрайти буде видалено.",
    confirm_delete_sheet: "Ви впевнені, що хочете видалити цей аркуш?",
    err_select_sprite: "Спочатку виберіть спрайт.",
    err_select_project: "Спочатку виберіть проект.",
    err_name_empty: "Назва не може бути пустою.",
    err_sprite_exists: "Спрайт із такою назвою вже існує.",
    err_project_exists: "Проект із такою назвою вже існує.",
    err_no_content: "Немає вмісту для збереження.",
    err_no_changes: "Немає змін для збереження.",
    err_delete_last_sheet: "Неможливо видалити останній аркуш.",
    err_extract_frames: "Не вдалося видобути жодного кадру.",
    err_indexeddb: "Не вдалося зберегти локально. Ваш браузер може не підтримувати IndexedDB.",
    msg_upload_success: "Успішне завантаження: {0}",
    msg_upload_failed: "Помилка завантаження: {0}",
    msg_save_success: "Збережено успішно.",
    msg_saving: "Збереження...",
    msg_multi_save_result: "Збережено ресурсів: {0}. {1} помилок.",
    menu_title: "Меню",
    menu_save: "зберегти",
    menu_save_all: "Зберегти все",
    menu_support: "Зверніться до служби підтримки",
    label_local_storage: "Локальна пам'ять",
    label_sign_in: "Увійти",
    modal_export_title: "Експорт Sprite",
    label_filename: "Ім'я файлу",
    label_format: "Формат",
    action_export_confirm: "Експорт",
};

export default translations;
